import React from 'react';
import { SkeletonLoader } from '@saviynt/design-system';

import { useInvertedLocalize } from '../../../utils';

import invertedMessages from './messages';

import './UserSkeleton.css';

const SKELETON_COUNT = 2;

function UserSkeleton() {
  const l = useInvertedLocalize(invertedMessages);

  return (
    <div
      className='Ext-UserSkeleton'
      role='status'
      aria-label={l('Loading users')}>
      <SkeletonLoader
        // TODO: DSD-155, @Sireesha, Needs Regression checked: Will likely need to send the height and width to the skeleton loader instead.
        shape='circle'
        animationStyle='wave'
        className='Ext-UserSkeleton-avatar'
      />
      <div className='Ext-UserSkeleton-userDetails'>
        {Array.from({ length: SKELETON_COUNT }).map(() => (
          <div className='Ext-UserSkeleton-userDetails-text'> </div>
        ))}
      </div>
    </div>
  );
}

export default UserSkeleton;
